import * as api from 'services/api'

const paper = {
	state: {
		//id: '',
		detail: {},
		params:{
			id:'',
			date:'',
			sysCode:''
		}
	},
	mutations: {
		'paper:clear'(state) {
			state.params.sysCode='';
			state.params.date='';
			state.params.id = '';
			state.detail = {};
		},
		'paper:update:params'(state,params) {
			state.params.sysCode=params.sysCode;
			state.params.date=params.date;
			state.params.id = params.id;
		},
		'paper:update:detail'(state, detail) {
			state.detail = detail;
		},
	},
	actions: {
		async 'paper:init'({commit, dispatch}, params) {
			commit('paper:clear');
			commit('paper:update:params',params);
			// 获取详情数据
			dispatch('paper:update:detail');
		},
		async 'paper:update:detail'({commit, state}) {

			const res = await api.getPagerDetail({sysCode:state.params.sysCode,articleId:state.params.id,date:state.params.date,paperName:"cdrb",platform:"android"});
			if(res.result.code == 0){
				let data = res.data;
				// let medias_o = data.medias || [];
				// let medias_n = [];
				// let orders = [];
				// for(let i = 0; i < medias_o.length; i++) {
				// 	if(orders.indexOf(medias_o[i].order) === -1) {
				// 		orders.push(medias_o[i].order);
				// 		medias_n.push(medias_o[i]);
				// 	}
				// }
				// data.medias = medias_n;
				commit('paper:update:detail', data);
			}
		},
		
	},
	getters: {
		'paper:detail': state => {
			return state.detail;
		},
	}
};

export default paper;


// WEBPACK FOOTER //
// ./src/store/modules/paper.js